export enum Country {
  FRANCE = 'FR',
  BELGIUM = 'BE',
  SWITZERLAND = 'CH',
  LUXEMBOURG = 'LU',
  SPAIN = 'ES',
  ITALY = 'IT',
  GERMANY = 'DE',
  UNITED_KINGDOM = 'GB',
  USA = 'US',
}
